import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ChatBubbleFilledSvg = function ChatBubbleFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.353 2.749c-5.328 0-9.648 4.253-9.648 9.5 0 2.066.671 3.98 1.809 5.539L2 21.749h10.353c5.328 0 9.647-4.253 9.647-9.5s-4.32-9.5-9.647-9.5m4.385 8.205h-8.77V9.226h8.77zm-8.77 4.318h6.139v-1.728h-6.14z",
    clipRule: "evenodd"
  }));
};
export var ChatBubbleFilled = function ChatBubbleFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ChatBubbleFilledSvg
  }));
};